
/**
 * name: 微应用名称 - 具有唯一性
 * entry: 微应用入口 - 通过该地址加载微应用
 * container: 微应用挂载节点 - 微应用加载完成后将挂载在该节点上
 * activeRule: 微应用触发的路由规则 - 触发路由规则后将加载该微应用
 */

const apps = [
    {
        name: 'teaching', // 子应用名称，保持唯一性
        entry: process.env.VUE_APP_TEACHING_ENTRY || '//localhost:5001', // 子应用入口，从环境变量读取
        container: '#sub-container', // 主应用中，组件中挂载子应用的 DOM
        activeRule: '/teaching', // 路由匹配规则
        props: {
            msg: '主应用与子应用通信传值',
        } // 主应用与子应用通信传值
    },
    {
        name: 'student', // 子应用名称，保持唯一性
        entry: process.env.VUE_APP_STUDENT_ENTRY || '//localhost:5005', // 子应用入口，从环境变量读取
        container: '#sub-container', // 主应用中，组件中挂载子应用的 DOM
        activeRule: '/student', // 路由匹配规则
        props: {
            msg: '主应用与子应用通信传值',
        } // 主应用与子应用通信传值
    },
    {
        name: 'evaluate', // 子应用名称，保持唯一性
        entry: process.env.VUE_APP_EVALUATE_ENTRY || '//localhost:5003', // 子应用入口，从环境变量读取
        container: '#sub-container', // 主应用中，组件中挂载子应用的 DOM
        activeRule: '/evaluate', // 路由匹配规则
        props: {
            msg: '主应用与子应用通信传值',
        } // 主应用与子应用通信传值
    },
    // {
    //     name: 'exploit', // 子应用名称，保持唯一性
    //     entry: process.env.VUE_APP_EXPLOIT_ENTRY || '//localhost:5006', // 子应用入口，从环境变量读取
    //     container: '#sub-container', // 主应用中，组件中挂载子应用的 DOM
    //     activeRule: '/exploit', // 路由匹配规则
    //     props: {
    //         msg: '主应用与子应用通信传值',
    //     } // 主应用与子应用通信传值
    // },
    {
        name: 'homework', // 作业管理微前端
        entry: process.env.VUE_APP_HOMEWORK_ENTRY || '//localhost:5007',
        container: '#sub-container',
        activeRule: '/homework',
        props: {
            msg: '主应用与子应用通信传值',
        }
    }
];


export default apps;
